import Grid from "@mui/material/Grid";
import {digitsEnToFa} from "persian-tools2";
import makeStyles from "@mui/styles/makeStyles";
import styles from 'assets/jss/Scan/scanStyle';
import {scanLevels} from 'helpers/scanLevels'

const useStyles = makeStyles(styles)

const ScanTitle = (props) => {
    const {nfcError, nfcStatus,totalNfcLength,nfcLength,isDemo} = props
    const classes = useStyles()

  return(
      <Grid item xs={12} mt='18px' minHeight={'40px'}>
          {nfcStatus === scanLevels.INITIAL_STATES && !nfcError ? (
              <p className={classes.purplebold}>درحال جستجوی NFC</p>
          ) : nfcStatus >= scanLevels.NFC_DATA_LENGTH && nfcStatus < scanLevels.NFC_FINISHED_OK && !nfcError ? (
              <Grid container direction={'row'}>
                  {/*<p className={classes.bloodTest}>درحال دریافت رکوردها</p>*/}

                  <p className={classes.totalSize}>{digitsEnToFa(totalNfcLength.toString())}</p>
                  <p className={classes.Slash}>/</p>
                  <p className={classes.currentSize}>{digitsEnToFa(nfcLength.toString())}</p>
                  <p className={classes.bloodTest}>تست قند</p>
              </Grid>
          ) : nfcError ? (
              ''
          ) : nfcStatus >= scanLevels.NFC_FINISHED_OK ? (
              isDemo ? (
                  <p className={classes.success}>
                      رکوردها با موفقیت دریافت شد
                  </p>
              ) : (
                  <p className={classes.success}>
                      {digitsEnToFa(totalNfcLength.toString())} رکورد با موفقیت دریافت شد
                  </p>
                  )

          ) : (
              ''
          )}
      </Grid>

  )
}
export default ScanTitle